<script>
import { UserService } from "@/service";
import Upload from "@/components/upload/index.vue";
export default {
	props: {
		// 标签数组
		dataSource: {
			default() {
				return [];
			},
		},
		// 用户详情
		infoData: {
			default() {
				return [];
			},
		},
		// 类型
		userType: {
			default: "",
		},
	},
	watch: {
		infoData: {
			immediate: true,
			// deep: true,
			handler(newValue, oldValue) {
				if (newValue && Object.keys(newValue).length > 0) {
					this.form = newValue;
					this.basicUrls = [...(newValue.technicalCertificates || [])];
				}
			},
		},
	},
	data() {
		return {
			basicUrls: [],
			form: {
				id: "",
				userType: "技术工程师",
				gender: "",
				age: "",
				technicalField: "",
				technicalOperatingDevice: "",
				technicalServiceDevice: "",
				technicalWorkingHours: "",
				technicalCertificates: [],
				technicalDescription: "",
			},
			rules: {
				gender: [{ required: true, message: "请选择性别", trigger: "change" }],
				age: [{ required: true, message: "请选择年龄", trigger: "change" }],
			},
		};
	},
	mounted() {},
	methods: {
		setState(obj) {
			for (let key in obj) {
				this.form[key] = obj[key];
			}
		},
		formChange(value) {
			this.setState({
				value,
			});
		},
		async handleSubmit() {
			this.$message.info("提交中...");
			const res = await UserService.SaveDescription({ ...this.form, userType: this.userType });
			if (res.code == 0) {
				this.$message.success("提交成功");
				this.$emit("refresh");
			}
		},
		RadioChange(key, value) {
			this.form[key] = ["id", "userType", "gender", "age"].includes(key) ? value : [value];
		},
		SelectChange(key, value) {
			const data = this.form[key] || [];
			let index = data.indexOf(value);
			if (index > -1) {
				data.splice(index, 1);
			} else {
				if (data?.length >= 5) {
					this.$message.warning("最多选择5个");
				} else {
					data.push(value);
				}
			}
			this.setState({ [key]: data });
		},
		onUploadSuccess(ids, key) {
			console.log("onUploadSuccess	", ids, key);
			this.setState({ [key]: ids });
		},
	},
	render() {
		const { dataSource, form, rules } = this;
		return (
			<el-form class="design-form" props={{ model: form, rules: rules }} label-width={"110px"}>
				<el-form-item label="性别：" prop="gender">
					<span onClick={() => this.RadioChange("gender", 1)} class={`label-data ${1 === parseInt(form.gender, 10) ? "active" : ""}`}>
						男
					</span>
					<span onClick={() => this.RadioChange("gender", 2)} class={`label-data ${2 === parseInt(form.gender, 10) ? "active" : ""}`}>
						女
					</span>
				</el-form-item>
				<el-form-item label="年龄：" prop="age">
					{dataSource[9]
						? dataSource[9].map((item, index) => {
								return (
									<span
										class={`label-data ${item.id === parseInt(form.age, 10) ? "active" : ""}`}
										key={index}
										onClick={() => this.RadioChange("age", item.id)}>
										{item.tagName}
									</span>
								);
						  })
						: ""}
				</el-form-item>

				<el-form-item label="擅长领域：">
					<el-input size="mini" placeholder="请输入..." v-model={form.technicalField} class="inputs-other" />
				</el-form-item>

				<el-form-item label="擅长操作设备：">
					<el-input size="mini" placeholder="请输入..." v-model={form.technicalOperatingDevice} class="inputs-other" />
				</el-form-item>

				<el-form-item label="擅长维修设备：">
					<el-input size="mini" placeholder="请输入..." v-model={form.technicalServiceDevice} class="inputs-other" />
				</el-form-item>

				<el-form-item label="工时费：">
					<el-input size="mini" placeholder="请输入..." v-model={form.technicalWorkingHours} class="inputs-other" />
				</el-form-item>

				<el-form-item label="等级证书：">
					<Upload
						basicIds={form.technicalCertificatesId}
						basicUrls={this.basicUrls}
						onUploadSuccess={(ids) => {
							this.onUploadSuccess(ids, "technicalCertificates");
						}}
					/>
				</el-form-item>
				<el-form-item label="技术能力描述：">
					<el-input size="mini" placeholder="请输入..." v-model={form.technicalDescription} class="inputs-other" />
				</el-form-item>
				<div style="text-align: center">
					<span class="label-data active btn" onClick={() => this.handleSubmit()}>
						确定
					</span>
				</div>
			</el-form>
		);
	},
};
</script>

<style lang="less" scoped>
@import "./skill.less";
</style>
